import React from 'react';
import { Toolbar } from '@mui/material';
import { useSelector } from 'react-redux';
import UserProfile from './UserProfile/UserProfile';
import { StyledAppBar } from './styled';
import { AppBarComponentProps } from './types';
import { SchoolInfo } from './SchoolInfo';
import { RootState } from '../../redux/store';
import { useSchoolConfig } from '../../utils/schoolConfigUtils';
import { SchoolConfig } from '../../types/schoolConfigType';

const AppBarComponent = ({
  open,
  anchorEl,
  handleMenuOpen,
  handleMenuClose
}: AppBarComponentProps) => {
  const schoolConfig = useSchoolConfig();
  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );
  return (
    <StyledAppBar position='fixed' open={open}>
      <Toolbar style={{ minHeight: '80px' }}>
        <SchoolInfo
          school={loggedInUser?.school}
          schoolConfig={schoolConfig as SchoolConfig}
        />
        <UserProfile
          anchorEl={anchorEl}
          handleMenuOpen={handleMenuOpen}
          handleMenuClose={handleMenuClose}
        />
      </Toolbar>
    </StyledAppBar>
  );
};

export default AppBarComponent;
